<template>
  <div
    :style="unico ? {} : { cursor: 'pointer' }"
    @click="unico ? '' : $emit('selecionar', valor)"
    class="container-cartao-vertical noselect"
    :class="{ selecionado: selecionado.includes(valor) }"
  >
    <div class="container-icone-sucesso">
      <unicom-icone
        :especuraDoIcone="1.5"
        class="arquivo"
        nome="file"
        :tamanho="44"
      />
      <unicom-icone
        class="sucesso"
        nome="check"
        :tamanho="16"
        :especuraDoIcone="3"
      />
    </div>
    <div class="subtitulo-vertical">
      {{ titulo }}
      <div class="segunda-cor-fonte mt-1">{{ subtitulo }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unico: {
      type: Boolean,
      default: false
    },
    valor: {
      type: [String, Number],
      default: ""
    },
    selecionado: {
      type: Array,
      default: () => []
    },
    titulo: {
      type: String
    },
    subtitulo: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.container-cartao-vertical {
  margin: 0px 16px;
  margin-bottom: 72px;
  min-width: 102px;
  min-height: 112px;
  background: #fdfdfd;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 32px 20px 24px 20px;
  display: flex;
  align-items: center;
  text-align: center;
  flex-flow: column;

  transition: all 0.2s;

  .container-icone-sucesso {
    position: relative;
    color: #00995d;
    width: 44px;
    margin-bottom: 24px;

    .sucesso {
      position: absolute;
      top: 38%;
      left: 29%;
    }
  }

  .subtitulo-vertical {
    word-break: break-all;
  }

  &.selecionado {
    box-shadow: 0px 2px 4px #60656c2e;
    border-color: #1daa7d;
  }
}
</style>
